import styles from './RewardBlock.module.scss';
import parse from 'html-react-parser';

export interface IRewardBlock {
  title: string;
  description: string;
  item_css: string;
  item: any;
}

const RewardBlock = (props: IRewardBlock) => {
  const today = new Date().toISOString().split('T')[0];

  return (
    <div className={styles.reward_block}>
      <h2 className={styles.reward_block__title}>{props?.title}</h2>
      <div className={styles.reward_block__description}>{parse(props?.description)}</div>
      <div className={styles.reward_block__grid}>
        {props.item.map(el => {
          const cssByDate = new Date(el?.date) < new Date(today) ? props?.item_css : '';

          return (
            <div key={el?.id} className={styles.reward_block__grid_item}>
              <img alt="" style={{ filter: cssByDate }} src={el?.image?.data?.attributes?.url} loading="lazy"></img>
              <p className={styles.reward_block__grid_item_title}>{el?.title}</p>
              <p className={styles.reward_block__grid_item_description}>{el?.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RewardBlock;
